
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-slate-50 to-gray-100 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-7 h-7 md:w-8 md:h-8 bg-gradient-to-br from-teal-500 to-emerald-600 rounded-lg flex items-center justify-center">
                <i className="ri-line-chart-line text-white text-base md:text-lg"></i>
              </div>
              <span className="text-base md:text-lg font-bold text-gray-900">DMM FXガイド</span>
            </div>
            <p className="text-xs md:text-sm text-gray-600 leading-relaxed">
              DMM FXの始め方から口コミ・評判まで、初心者にも分かりやすく解説します。
            </p>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-3 md:mb-4 text-xs md:text-sm">人気記事</h3>
            <ul className="space-y-1.5 md:space-y-2">
              <li><Link to="/reviews" className="text-xs md:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">口コミ・評判</Link></li>
              <li><Link to="/beginner-guide" className="text-xs md:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">初心者ガイド</Link></li>
              <li><Link to="/account-opening" className="text-xs md:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">口座開設手順</Link></li>
              <li><Link to="/spread" className="text-xs md:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">スプレッド比較</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-gray-900 mb-3 md:mb-4 text-xs md:text-sm">お役立ち情報</h3>
            <ul className="space-y-1.5 md:space-y-2">
              <li><Link to="/comparison" className="text-xs md:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">他社比較</Link></li>
              <li><Link to="/campaign" className="text-xs md:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">キャンペーン</Link></li>
              <li><Link to="/safety" className="text-xs md:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">安全性について</Link></li>
              <li><Link to="/disadvantages" className="text-xs md:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">デメリット</Link></li>
            </ul>
          </div>

          <div className="col-span-2 md:col-span-1">
            <h3 className="font-semibold text-gray-900 mb-3 md:mb-4 text-xs md:text-sm">FX基礎知識</h3>
            <ul className="grid grid-cols-2 md:grid-cols-1 gap-1.5 md:gap-2">
              <li><Link to="/fx-basics" className="text-xs md:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">FXとは</Link></li>
              <li><Link to="/how-to-choose" className="text-xs md:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">証券会社の選び方</Link></li>
              <li><Link to="/leverage" className="text-xs md:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">レバレッジ</Link></li>
              <li><Link to="/trading-hours" className="text-xs md:text-sm text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">取引時間</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-6 md:mt-8 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-xs md:text-sm text-gray-500 text-center md:text-left">© 2025 DMM FXガイド. All rights reserved.</p>
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-xs md:text-sm text-gray-500 hover:text-teal-600 transition-colors cursor-pointer">
            Web Design
          </a>
        </div>
      </div>
    </footer>
  );
}
